import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

const Background = styled(Box)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: url("/images/background/background12.jpg") center/cover no-repeat;
  z-index: -1;
  /* filter: blur(6px); */
  /* -webkit-filter: blur(6px); */
  /* transform: scale(1.02); */
  /*
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.2);
    pointer-events: none;
  }
  */
`;

export default Background;
